import type { FC } from 'react'
import { Trans } from 'react-i18next'

import { TypographyText } from '~/core/ui/Text'

import type { INotification, INotificationCompany } from '~/lib/features/notifications/types'

import NotificationItemLayout from './NotificationItemLayout'

const UserDeleteCompany: FC<{
  notification: INotification
  onClick: () => void
  onDelete: () => void
  isLoadingDeleted: boolean
}> = ({ notification, onClick, onDelete, isLoadingDeleted }) => {
  const propertiesRelated = notification?.payload as INotificationCompany

  return (
    <NotificationItemLayout
      onDelete={onDelete}
      isLoadingDeleted={isLoadingDeleted}
      user={notification.user}
      actionType={notification.actionType}
      readAt={notification.readAt}
      createdAt={notification.createdAt}>
      {({ time }) => (
        <>
          <TypographyText
            className="cursor-pointer text-sm text-gray-700"
            onClick={() => {
              onClick && onClick()
            }}>
            <Trans
              i18nKey="activity:notification:userDeleteCompany"
              values={{
                userName: notification?.user?.fullName,
                companyName: propertiesRelated?.companyName
              }}>
              <span className="font-medium text-gray-900" />
            </Trans>
            {time}
          </TypographyText>
        </>
      )}
    </NotificationItemLayout>
  )
}

export default UserDeleteCompany
